import React from 'react';
import Button from '@components/atoms/Button';
import { TotalDiscount } from '@interfaces/cart';
import Icon from '@components/atoms/Icon';
import { formatMoney } from '@helpers/global';

interface OrderSummaryProps {
  isCartPage: boolean;
  subtotal: { amount: string; currencyCode: string };
  totalDiscount: TotalDiscount;
}

const CartOrderSummary: React.FC<OrderSummaryProps> = ({ isCartPage, subtotal, totalDiscount }) => {
  const strings = window.DEPT.Strings.cart;

  if (!isCartPage) {
    return (
      <div className="flex flex-col mt-1">
        <div className="flex items-center justify-between gap-4 body-xs font-medium text-black p-2.5" data-savedby-slot-target="info:below">
          <span>{strings.subtotal}</span>
          <span data-savedby-slot-type="subtotal-with-fee">
            {formatMoney({
              amount: String(subtotal.amount),
              currencyCode: subtotal.currencyCode
            }) || ''}
          </span>
        </div>
        <div className="w-full flex flex-wrap p-2.5 gap-4">
          <Button
            mode="link"
            url="/checkout"
            className="flex-1 min-w-52.25"
            buttonText={strings.proceedToCheckout}
          />
          <Button
            mode="link"
            url="/cart"
            variant="secondary"
            className="flex-1 min-w-37"
            buttonText={strings.viewCart}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col p-2.5 bg-grey-9 md:flex-1 md:max-w-[474px]">
      <h3 className="h3">{strings.orderSummary}</h3>
      <div className="flex flex-col bg-white p-4">
        <div className="flex items-center justify-between body-sm text-black">
          <span>{strings.subtotal}</span>
          <span>
            {formatMoney({
              amount: String(subtotal.amount),
              currencyCode: subtotal.currencyCode
            }) || '$0.00'}
          </span>
        </div>
        <div className="flex justify-between body-sm text-black">
          <span>{strings.discounts}</span>
          <span className="flex gap-0 items-center">
            {Number(totalDiscount.amount) !== 0 && <Icon name="minus" className="text-black w-2.5" strokeWidth={1.5} />}
            {formatMoney({
              amount: String(totalDiscount.amount),
              currencyCode: totalDiscount.currencyCode
            }) || '$0.00'}
          </span>
        </div>
        <div className="flex justify-between body-sm text-black">
          <span>{strings.shipping}</span>
          <span>{strings.calculatedAtCheckout}</span>
        </div>
        <div className="flex justify-between body-sm text-black">
          <span>{strings.taxes}</span>
          <span>{strings.calculatedAtCheckout}</span>
        </div>
        <div className="h-px bg-grey-8 my-2.25" />
        <div className="flex justify-between body-sm font-medium text-black">
          <span>{strings.discountAdded}</span>
          <span>
            {formatMoney({
              amount: String(totalDiscount.amount),
              currencyCode: totalDiscount.currencyCode
            }) || '$0.00'}
          </span>
        </div>
        <Button
          mode="link"
          url="/checkout"
          className="flex-1 min-w-52.25 mt-6"
          buttonText={strings.proceedToCheckout}
        />
      </div>
    </div>
  );
};

export default CartOrderSummary;
